module.exports = __webpack_public_path__ + "static/media/login-banner2.4de21f09.jpg";